export const loadImage = (src: string, crossOrigin?: boolean) => {
    return new Promise<{
        image: HTMLImageElement;
        width: number;
        height: number;
        error?: boolean;
    }>((resolve, _reject) => {
        const image = new Image();
        image.src = src;
        if (crossOrigin) image.crossOrigin = "Anonymous";

        image.onload = () => {
            resolve({
                image,
                width: image.width,
                height: image.height,
            });
        };

        image.onerror = () => {
            console.log("image.onerror");
            resolve({
                image,
                width: 0,
                height: 0,
                error: true,
            });
        };
    });
};
